/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFunctionGrid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path
          clipRule="evenodd"
          d="M2 2h9v9H2zm2 2v5h5V4zm9-2h9v9h-9zm2 2v5h5V4zM2 13h9v9H2zm2 2v5h5v-5z"
          fillRule="evenodd"
        />
        <path d="m13 23.168.373-.405c.233-.255.41-.514.53-.776a4.09 4.09 0 0 0 .294-.956l.847-4.353h-.982l.147-.754 1.039-.303.124-.585c.136-.69.392-1.2.768-1.53.377-.337.892-.506 1.547-.506.136 0 .264.008.384.023.12.007.234.018.34.033l-.204 1.035h-.373c-.331 0-.583.083-.756.247-.174.158-.294.42-.362.788l-.102.483h1.345l-.204 1.069h-1.333l-.858 4.454a4.97 4.97 0 0 1-.271.967c-.105.278-.245.54-.418.788s-.4.51-.678.787L13.87 24zm4.302-1.642 2.62-3.116-1.4-2.8h1.468l.904 2.002 1.615-2.003H24l-2.474 2.913 1.514 3.004h-1.423l-1.05-2.194-1.763 2.194z" />
      </g>
    </g>
  </Icon>
);
export { SvgFunctionGrid as FunctionGrid };
